





















































// doc: https://github.com/kaorun343/vue-property-decorator
import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import ViewBase from "@/utils/ViewBase";
import UrlManager from "@/utils/UrlManager";
import { resetPassword, logout, verifyEmailActiveCode } from "@/api/login";
import setlan from "@/utils/setLan.ts";

@Component
export default class Model extends Mixins(ViewBase, UrlManager, setlan) {
  @Prop({ type: Boolean, default: false }) value!: boolean;

  form: any = null;
  orderAttrList: any = [];
  defQuery: any = {
    activeCode: "",
    email: "",
    newPassword: "",
    confirmPassword: ""
  };
  query: any = {
    activeCode: "",
    email: "",
    newPassword: "",
    confirmPassword: ""
  };
  keys: any = [];
  plainOptions: any = [];
  findSuccess: any = false;
  findError: any = false;

  created() {
    this.form = this.$form.createForm(this);
  }

  mounted() {
    this.updateQueryByParam();
    this.verifyEmailActiveCode();
  }
  async verifyEmailActiveCode() {
    try {
      // 获取日历列表页
      const email = this.query.email;
      const activeCode = this.query.activeCode;
      const { data } = await verifyEmailActiveCode({ email, activeCode });
      if (!data.success) {
        this.$message.error(data.msg);
      }
    } catch (ex) {
      this.handleError(ex);
    }
  }

  async init(query: any, orderAttrList: any) {
    this.orderAttrList = orderAttrList;
    this.query = query;
    orderAttrList.map((it: any) => this.plainOptions.push(it.key));
  }

  handleCancel() {
    this.form.resetFields();
    this.$emit("input", false);
    this.keys = [];
    this.plainOptions = [];
    this.findError = false;
    this.findSuccess = false;
    this.query.newPassword = "";
    this.query.confirmPassword = "";
  }

  async findPassword() {
    try {
      const reg = /(^\s*|\s*$)/g;
      const { data } = await resetPassword({
        activeCode: this.query.activeCode,
        email:this.query.email,
        newPassword: (this.query.newPassword + "").replace(reg, ""),
        confirmPassword: (this.query.confirmPassword + "").replace(reg, "")
      });
      if (data.success) {
        this.$message.success(data.msg);
        logout();
        localStorage.removeItem("user");
        this.$router.push("/login");
      } else {
        this.$message.error(data.msg);
      }
    } catch (ex) {
      this.handleError(ex);
    }
  }
}
